(() => {
  const init = () => {
    const searchToggle = document.querySelector('.sw-search-toggle');
    const searchForm = document.querySelector('#sw-header-search');
    const closeSearch = () => { if (!searchForm || !searchToggle) return; searchForm.hidden = true; searchToggle.setAttribute('aria-expanded', 'false'); };
    searchToggle?.addEventListener('click', () => {
      const open = searchForm.hidden;
      searchForm.hidden = !open;
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) searchForm.querySelector('input[type="search"]')?.focus();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && searchForm && !searchForm.hidden) { closeSearch(); searchToggle.focus(); }
    });
    const menu = document.querySelector('.sw-menu-toggle');
    const nav = document.querySelector('.sw-navigation');
    menu?.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') {
        menu.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        menu.focus();
      }
    });
    document.querySelectorAll('[data-sw-image]').forEach(button => {
      button.addEventListener('click', () => {
        const image = document.querySelector('.sw-main-image');
        if (!image) return;
        image.src = button.dataset.swImage;
        image.removeAttribute('srcset');
        image.alt = button.getAttribute('aria-label');
      });
    });
    document.querySelector('[data-sw-variant]')?.addEventListener('change', event => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.assign(url);
    });
    // Separate colour products belong together on the full product page.
    const productForm = document.querySelector('.sw-product-form');
    if (productForm && !productForm.querySelector('[data-sw-variant]') && !productForm.querySelector('[data-sw-sibling-colour]')) {
      const asset = Array.from(document.scripts).find(script => script.src.includes('/assets/sw-theme.js'));
      const handle = location.pathname.split('/products/')[1]?.split('/')[0];
      if (asset && handle) {
        fetch(new URL('sw-preview-catalog.json', asset.src)).then(response => {
          if (!response.ok) throw new Error('Catalog unavailable');
          return response.json();
        }).then(async catalog => {
          const items = Array.isArray(catalog) ? catalog : catalog.products;
          const current = items?.find(item => item.handle === handle);
          if (!current?.family) return;
          const siblings = items.filter(item => item.family === current.family);
          if (siblings.length < 2) return;
          const root = location.pathname.split('products/')[0];
          const choices = (await Promise.all(siblings.map(async item => {
            try {
              const response = await fetch(root + 'products/' + item.handle + '.js');
              if (!response.ok) return null;
              const live = await response.json();
              return { ...item, available: live.available, price: live.price / 100 };
            } catch { return null; }
          }))).filter(Boolean);
          if (choices.length < 2) return;
          const label = document.createElement('label');
          label.htmlFor = 'sw-product-colour';
          label.textContent = 'Kleur of uitvoering';
          const select = document.createElement('select');
          select.id = 'sw-product-colour';
          const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
          choices.forEach(item => {
            const option = document.createElement('option');
            option.value = root + 'products/' + item.handle;
            option.textContent = (item.color || item.title) + ' — ' + money.format(item.price) + (item.available ? '' : ' (uitverkocht)');
            option.selected = item.handle === handle;
            select.append(option);
          });
          select.addEventListener('change', () => location.assign(select.value));
          const quantity = productForm.querySelector('label[for="sw-quantity"]');
          productForm.insertBefore(label, quantity);
          productForm.insertBefore(select, quantity);
        }).catch(() => {});
      }
    }
    document.querySelector('[data-sw-sibling-colour]')?.addEventListener('change', event => {
      const target = new URL(event.target.value, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      location.assign(target);
    });
    const configNode = document.getElementById('sw-preview-config');
    if (!configNode) {
      document.querySelectorAll('[data-sw-catalog]').forEach(container => {
        container.querySelector('[data-sw-type]')?.closest('label').setAttribute('hidden','');
        const select = container.querySelector('[data-sw-sort]');
        const sort = new URLSearchParams(location.search).get('sort_by');
        if (sort) select.value = sort;
        select?.addEventListener('change', event => {
          const url = new URL(location.href);
          url.searchParams.set('sort_by', event.target.value === 'recommended' ? 'manual' : event.target.value);
          url.searchParams.delete('page');
          location.assign(url);
        });
      });
      return;
    }
    const config = JSON.parse(configNode.textContent);
    const t = Object.fromEntries(Object.entries(config.copy).map(([key,value]) => [key, String(value).replaceAll('&amp;','&')]));
    const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    const money = value => new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(value);
    const urlImage = (url, width=640) => url + (url.includes('?') ? '&' : '?') + 'width=' + width;
    const dialog = document.querySelector('.sw-product-dialog');
    let products = [];
    let groups = [];
    let trigger = null;
    let pageScrollY = 0;
    const dialogScroll = dialog.querySelector('.sw-dialog-scroll');
    const close = () => dialog.close();
    dialog.querySelector('.sw-dialog-close').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => {
      const scrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.documentElement.classList.remove('sw-dialog-open');
      document.body.classList.remove('sw-dialog-open');
      document.body.style.removeProperty('--sw-page-scroll-offset');
      window.scrollTo(0, pageScrollY);
      trigger?.focus({preventScroll: true});
      requestAnimationFrame(() => { document.documentElement.style.scrollBehavior = scrollBehavior; });
    });
    function openProduct(id, origin) {
      const product = products.find(item => item.id === id);
      if (!product) return;
      const group = groups.find(item => item.items.some(p => p.id === id));
      if (origin) trigger = origin;
      const previousScrollTop = origin ? 0 : dialogScroll.scrollTop;
      const sameColour = new Set(group.items.map(item => item.color)).size <= 1;
      const choiceLabel = sameColour ? t.version : t.color;
      const choices = group.items.length > 1 ? `<div class="sw-dialog-choices"><p>${escape(choiceLabel)}: <strong>${escape(sameColour ? product.title : product.color || product.title)}</strong></p><div class="sw-choice-buttons">${group.items.map(item => `<button type="button" class="sw-choice" data-sw-choice="${escape(item.id)}" aria-pressed="${item.id === id}">${item.swatch && !sameColour ? `<span class="sw-swatch" style="--swatch:${escape(item.swatch)}"></span>` : ''}${escape(sameColour ? item.title.replace(/ - zwart/gi,'') : item.color || item.title)}</button>`).join('')}</div></div>` : '';
      const photos = (product.images?.length ? product.images : product.image ? [{url: product.image}] : []).map(photo => typeof photo === 'string' ? {url: photo} : photo);
      const image = photos.length ? `<div class="sw-dialog-gallery"><img class="sw-dialog-main-image" src="${escape(urlImage(photos[0].url,1000))}" alt="${escape(photos[0].altText || product.originalTitle)}" width="700" height="700">${photos.length > 1 ? `<div class="sw-dialog-thumbnails">${photos.map((photo,index) => `<button type="button" data-sw-photo="${index}" aria-pressed="${index === 0}" aria-label="${escape(product.title)} — ${index+1}/${photos.length}"><img src="${escape(urlImage(photo.url,160))}" alt="" width="80" height="80" loading="lazy"></button>`).join('')}</div>` : ''}</div>` : '';
      const productInfo = product.descriptionHtml || `<p>${escape(product.description)}</p>`;
      dialog.querySelector('.sw-dialog-content').innerHTML = `<div class="sw-dialog-image">${image}</div><div class="sw-dialog-info"><p class="sw-eyebrow">${escape(product.categoryTitle)} / ${escape(product.sub)}</p><h2 id="sw-dialog-title" tabindex="-1">${escape(group.items.length > 1 ? group.name : product.title)}</h2><p class="sw-dialog-price">${money(product.price)}</p><p class="sw-tax">${escape(t.included_tax)}</p>${choices}${config.preview ? `<p class="sw-availability">${escape(t.soon)}</p>` : ''}<div class="sw-dialog-description">${productInfo}</div>${!config.preview ? `<label for="sw-dialog-quantity">Aantal</label><input id="sw-dialog-quantity" required type="number" min="1" step="1" value="1" inputmode="numeric" style="display:block;width:80px;padding:10px;margin:8px 0 16px"><p data-sw-cart-status role="status" aria-live="polite"></p>` : ''}</div>`;
      dialog.querySelector('.sw-dialog-actions').innerHTML = `${config.preview ? `<a class="sw-button" href="${escape(config.root+'pages/contact')}">${escape(t.ask)}</a>` : `<button type="button" class="sw-button" data-sw-add-cart ${product.available ? '' : 'disabled'}>${product.available ? 'Stop in winkelwagen' : 'Uitverkocht'}</button>`}`;
      dialog.querySelector('[data-sw-add-cart]')?.addEventListener('click', async event => {
        const button = event.currentTarget;
        const quantityInput = dialog.querySelector('#sw-dialog-quantity');
        const quantity = Number(quantityInput.value);
        if (!Number.isInteger(quantity) || quantity < 1) {quantityInput.reportValidity();return;}
        const status = dialog.querySelector('[data-sw-cart-status]');
        const choices = [...dialog.querySelectorAll('[data-sw-choice]')];
        button.disabled = true;
        quantityInput.disabled = true;
        choices.forEach(choice => choice.disabled = true);
        button.textContent = 'Toevoegen…';
        status.textContent = '';
        try {
          const response = await fetch(config.root+'cart/add.js', {
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:product.variantId,quantity}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Toevoegen is niet gelukt. Probeer opnieuw.');
          status.innerHTML = `Toegevoegd aan je winkelmand. <a href="${escape(config.root+'cart')}">Bekijk winkelmand</a>`;
          // Refresh the header count without an extra shopping step.
          try {
            const cartResponse = await fetch(config.root+'cart.js',{cache:'no-store'});
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('a[href="'+config.root+'cart"]').forEach(link => {
                if (link.closest('.sw-product-dialog')) return;
                const label = 'Winkelwagen ('+cart.item_count+')';
                link.setAttribute('aria-label',label);
                const count = link.querySelector('.sw-cart-count');
                if (count) count.textContent = cart.item_count;
              });
            }
          } catch (_) {}
        } catch (error) {
          status.textContent = error.message || 'Toevoegen is niet gelukt. Probeer opnieuw.';
        } finally {
          button.disabled = false;
          quantityInput.disabled = false;
          choices.forEach(choice => choice.disabled = false);
          button.textContent = 'Stop in winkelwagen';
        }
      });
      dialog.querySelectorAll('[data-sw-photo]').forEach(button => button.addEventListener('click', () => {
        const photo = photos[Number(button.dataset.swPhoto)];
        const main = dialog.querySelector('.sw-dialog-main-image');
        main.src = urlImage(photo.url,1000);
        main.alt = photo.altText || product.originalTitle;
        dialog.querySelectorAll('[data-sw-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      dialog.querySelectorAll('[data-sw-choice]').forEach(button => button.addEventListener('click', () => {
        openProduct(button.dataset.swChoice);
        dialog.querySelector(`[data-sw-choice="${button.dataset.swChoice}"]`)?.focus({preventScroll: true});
      }));
      if (!dialog.open) {
        pageScrollY = window.scrollY;
        document.body.style.setProperty('--sw-page-scroll-offset', `${-pageScrollY}px`);
        document.documentElement.classList.add('sw-dialog-open');
        document.body.classList.add('sw-dialog-open');
        dialog.showModal();
        dialog.querySelector('#sw-dialog-title').focus({preventScroll: true});
      }
      dialogScroll.scrollTop = previousScrollTop;
    }
    function card(group) {
      const product = group.items.find(item => item.available) || group.items[0];
      const prices = group.items.map(p => p.price);
      const price = Math.min(...prices);
      const vary = new Set(prices).size > 1;
      const href = config.root + 'products/' + product.handle;
      return `<article class="sw-card"><a class="sw-card-image${product.lifestyle ? ' sw-lifestyle' : ''}" href="${escape(href)}" aria-label="${escape(t.show_details)}: ${escape(group.name)}">${product.image ? `<img src="${escape(urlImage(product.image))}" alt="${escape(group.name)}" width="640" height="640" loading="lazy">` : ''}${config.preview ? `<span class="sw-badge">${escape(t.soon)}</span>` : ''}</a><div class="sw-card-meta"><p class="sw-card-type">${escape(product.sub)}</p><h3><a class="sw-card-title" href="${escape(href)}">${escape(group.name)}</a></h3><div class="sw-card-foot"><p class="sw-price">${vary ? escape(t.from)+' ' : ''}${money(price)}</p></div></div></article>`;
    }
    function bindCards(container) {}
    function setupCatalog(container) {
      if (container.dataset.category === 'heerlijk-warm-op-de-bank') {
        container.querySelector('[data-sw-type]')?.closest('label')?.setAttribute('hidden', '');
        const count = container.querySelector('[data-sw-count]');
        if (count) count.textContent = container.querySelectorAll('[data-sw-grid] > article').length + ' producten';
        const sorter = container.querySelector('[data-sw-sort]');
        const currentSort = new URLSearchParams(location.search).get('sort_by');
        if (currentSort) sorter.value = currentSort;
        sorter?.addEventListener('change', event => {
          const target = new URL(location.href);
          target.searchParams.set('sort_by', event.target.value === 'recommended' ? 'manual' : event.target.value);
          target.searchParams.delete('page');
          location.assign(target);
        });
        return;
      }
      const requested = new URLSearchParams(location.search).get('category');
      const category = ['koken-gezellig-tafelen','opbergen','kleding-was','badkamer','wonen','heerlijk-warm-op-de-bank'].includes(requested) ? requested : container.dataset.category;
      container.dataset.category = category;
      if (category !== 'all' && category !== 'heerlijk-warm-op-de-bank') {
        document.querySelectorAll('[data-sw-category-title]').forEach(node => node.textContent = t[category.replaceAll('-','_')]);
        document.querySelectorAll('[data-sw-category]').forEach(node => { if (node.dataset.swCategory === category) node.setAttribute('aria-current','page'); else node.removeAttribute('aria-current'); });
      }
      const intro = document.querySelector('[data-sw-category-description]');
      if (intro && category !== 'heerlijk-warm-op-de-bank') intro.textContent = t['intro_'+category.replaceAll('-','_')] || '';
      const search = (container.dataset.search || '').trim().toLocaleLowerCase('nl');
      let candidates = groups.filter(group => (category === 'all' || group.items[0].category === category || (category === 'heerlijk-warm-op-de-bank' && group.items.some(item => ["sherpa-plaid-beige-150x200","sherpa-plaid-antraciet-150x200","extra-grote-plaid-taupe-200x240","hoodie-voor-vrouwen-creme","hoodie-voor-vrouwen-grijs","hoodie-voor-vrouwen-bruin","ceruzo-sherpa-fleece-deken-150x200-cm-licht-grijs","ceruzo-sherpa-fleece-deken-150x200-cm-roze","ceruzo-sherpa-fleece-deken-150x200-cm-paars","ceruzo-sherpa-fleece-deken-150x200-cm-blauw","hoodie-voor-vrouwen-roze"].includes(item.handle)))) && (!search || search.split(/\s+/).every(term => `${group.name} ${group.items.map(p => p.originalTitle+' '+p.title+' '+(p.keywords || '')+' '+p.sub+' '+p.categoryTitle).join(' ')}`.toLocaleLowerCase('nl').includes(term))));
      const filter = container.querySelector('[data-sw-type]');
      const sorter = container.querySelector('[data-sw-sort]');
      const count = container.querySelector('[data-sw-count]');
      const grid = container.querySelector('[data-sw-grid]');
      const more = container.querySelector('[data-sw-more]');
      const types = [...new Set(candidates.map(p => p.items[0].sub))].sort((a,b)=>a.localeCompare(b,'nl'));
      filter.innerHTML = `<option value="">${escape(t.all_types)}</option>`+types.map(type => `<option value="${escape(type)}">${escape(type)}</option>`).join('');
      const params = new URLSearchParams(location.search);
      if (types.includes(params.get('type'))) filter.value = params.get('type');
      if ([...sorter.options].some(option => option.value === params.get('sort_by'))) sorter.value = params.get('sort_by');
      let limit = 24;
      function render() {
        const selected = candidates.filter(p => !filter.value || p.items[0].sub === filter.value);
        if (sorter.value === 'recommended') selected.sort(compareGroups);
        if (sorter.value === 'price-ascending') selected.sort((a,b)=>Math.min(...a.items.map(p=>p.price))-Math.min(...b.items.map(p=>p.price)));
        if (sorter.value === 'price-descending') selected.sort((a,b)=>Math.min(...b.items.map(p=>p.price))-Math.min(...a.items.map(p=>p.price)));
        if (sorter.value === 'title-ascending') selected.sort((a,b)=>a.name.localeCompare(b.name,'nl'));
        count.textContent = `${selected.length} ${selected.length === 1 ? t.result : t.results}`;
        if (container.hasAttribute('data-search')) document.title = `${t.search_results} — Forest26`;
        let previousSection = '';
        grid.innerHTML = selected.length ? selected.slice(0,limit).map(group => {
          const product = group.items[0];
          const section = `${product.category}:${product.sub}`;
          let heading = '';
          if (sorter.value === 'recommended' && section !== previousSection) {
            const label = category === 'all' ? `${product.categoryTitle} · ${product.sub}` : product.sub;
            heading = `<div class="sw-product-group-heading"><h2>${escape(label)}</h2></div>`;
            previousSection = section;
          }
          return heading + card(group);
        }).join('') : `<div class="sw-empty-results"><p>${escape(t.no_results)}</p>${filter.value ? `<button type="button" class="sw-button sw-button-outline" data-sw-reset>${escape(t.reset)}</button>` : ''}</div>`;
        bindCards(grid);
        more.hidden = selected.length <= limit;
        grid.querySelector('[data-sw-reset]')?.addEventListener('click',()=>{filter.value='';render();});
      }
      filter.addEventListener('change',()=>{limit=24;render();});
      sorter.addEventListener('change',()=>{limit=24;render();});
      more.addEventListener('click',()=>{limit+=24;render();});
      render();
    }
    const categoryOrder = ['koken-gezellig-tafelen','opbergen','kleding-was','badkamer','wonen'];
    const typeOrder = ['Sieraden','Horloges & brillen','Manden & organizers','Bureau','Schoenen & kleding opbergen','Wasmanden & wassorteerders','Was drogen','Badkameropbergers','Handdoekrekken','Badkameraccessoires','Pedaalemmers','Bijzettafels','Poefs & krukjes','Armleuningdienbladen','Plaids & dekens','Wandplanken & standaards','Sfeer','Verlichting','Koken & voorbereiden','Serveren & borrelen','Koffie & thee','Lade & kast','Aanrecht & voorraad','Tafelen & serveren','Wijn & bar'];
    const families = [/sieraden|juwelen/i,/horloge/i,/brillen/i,/bestekbak/i,/pannenrek/i,/keukenkast/i,/messenblok/i,/broodtrommel/i,/theekist/i,/kruiden/i,/capsule/i,/fruit/i,/meal prep/i,/keukenrol/i,/onderzetter|pannenlappen/i,/dienblad|lazy susan/i,/stolp/i,/etagere/i,/kookschort/i,/kookwekker/i,/theelicht/i,/wijnrek/i,/wijnkoeler|champagnekoeler/i,/ijsemmer/i,/barset/i];
    function compareGroups(a,b) {
      const left = a.items[0], right = b.items[0];
      const familyRank = group => {
        const index = families.findIndex(pattern => pattern.test(group.name));
        return index < 0 ? families.length : index;
      };
      return categoryOrder.indexOf(left.category)-categoryOrder.indexOf(right.category)
        || typeOrder.indexOf(left.sub)-typeOrder.indexOf(right.sub)
        || familyRank(a)-familyRank(b)
        || a.name.localeCompare(b.name,'nl',{numeric:true});
    }
    fetch(config.url).then(response => {
      if (!response.ok) throw new Error('Catalogue unavailable');
      return response.json();
    }).then(async data => {
      if (!config.preview) {
        // Shopify is the price source for cards, details and ordering.
        const current = new Map();
        for (let page = 1; ; page++) {
          const response = await fetch(config.root + 'products.json?limit=250&page=' + page, {cache:'no-store'});
          if (!response.ok) throw new Error('Current prices unavailable');
          const live = (await response.json()).products;
          if (!Array.isArray(live)) throw new Error('Invalid product response');
          for (const item of live) current.set(item.handle,item);
          if (live.length < 250) break;
        }
        const importMeta = {"19353.5":["Wereldbollamp — USB, 31 cm — zwart","wonen","Verlichting","Zwart","#222"],"19360.3":["Wereldbollamp — USB, 31 cm — wit","wonen","Verlichting","Wit","#fff"],"78761.4":["Wandrek met spiegel — 3 planken","wonen","Wandplanken & standaards"],"59447.9":["Plantenstandaards — set van 2","wonen","Wandplanken & standaards"],"05250.4":["Tafellamp — 24 cm — zwart","wonen","Verlichting"],"DS80891":["Tafellamp van draad — 19 cm","wonen","Verlichting"],"58384.8":["Dimbare USB-touchlamp — 34 cm — taupe","wonen","Verlichting"],"02327.8":["Dimbare USB-touchlamp — zwart","wonen","Verlichting"],"58353.4":["Dimbare USB-touchlamp","wonen","Verlichting"],"02328.5":["Dimbare USB-touchlamp — grijs","wonen","Verlichting"],"54795.6":["Handdoekrek — metaal en bamboe","badkamer","Handdoekrekken"],"87367.5":["Dubbele uitschuifbare wasmand","kleding-was","Wasmanden & wassorteerders"],"DS53869":["Bijzettafel — zwart, 40 × 26 × 58 cm","wonen","Bijzettafels"],"87390.3":["Bijzettafel met tijdschriftenhouder","wonen","Bijzettafels"],"87320.0":["Handdoekrek — metaal en MDF","badkamer","Handdoekrekken"],"87319.4":["Extra breed handdoekrek — 90 cm","badkamer","Handdoekrekken"],"87472.6":["Fleece deken — 150 × 200 cm — denimblauw","wonen","Plaids & dekens"],"87365.1":["Wandhanddoekrek — metaal en hout","badkamer","Handdoekrekken"]};
        const knownHandles = new Set(data.map(item => item.handle));
        for (const live of current.values()) {
          const sku = live.variants.map(variant => String(variant.sku || "").replace(/^16986\./, "")).find(sku => importMeta[sku]);
          if (!sku || knownHandles.has(live.handle)) continue;
          const [title,category,sub,color='',swatch=''] = importMeta[sku];
          const images = live.images.map(image => ({url:image.src,altText:image.alt || title}));
          data.push({id:String(live.id),handle:live.handle,title,originalTitle:live.title,category,categoryTitle:({'wonen':'Wonen','badkamer':'Badkamer','kleding-was':'Kleding & was'})[category],sub,family:'',color,swatch,image:images[0]?.url || '',images,description:live.body_html,status:'ACTIVE',url:'/products/'+live.handle,lifestyle:false});
          knownHandles.add(live.handle);
        }
        data = data.filter(item => current.has(item.handle)).map(item => {
          const live = current.get(item.handle);
          const variant = live.variants.find(option => option.available) || live.variants[0];
          const price = Number(variant?.price);
          if (!Number.isFinite(price)) throw new Error('Invalid current price');
          return {...item,title:live.title,price,variantId:variant.id,available:variant.available,descriptionHtml:live.body_html};
        });
      }
      products = data;
      const byGroup = new Map();
      const priority = ['16061978640715','16061988503883','16061985521995','16061991256395','16061983818059','16061986505035','16061982245195','16061982376267'];
      products.sort((a,b) => (priority.indexOf(a.id)<0?999:priority.indexOf(a.id))-(priority.indexOf(b.id)<0?999:priority.indexOf(b.id)));
      for (const product of products) {
        const key = product.family || product.id;
        if (!byGroup.has(key)) byGroup.set(key,{name:product.family || product.title,items:[]});
        byGroup.get(key).items.push(product);
      }
      groups = [...byGroup.values()];
      document.querySelectorAll('[data-sw-featured]').forEach(container => {
        const ids = container.dataset.swFeatured === 'table' ? ['16062917738827','16062917968203','16062917869899','16061978640715'] : container.dataset.swFeatured === 'living' ? priority.slice(4) : priority.slice(0,4);
        const selected = ids.map(id => groups.find(p => p.items.some(item=>item.id===id))).filter(Boolean);
        container.innerHTML = selected.map(card).join('');
        bindCards(container);
      });
      document.querySelectorAll('[data-sw-catalog]').forEach(container => {
        setupCatalog(container);
      });
    }).catch(() => {
      document.querySelectorAll('[data-sw-catalog]').forEach(container => {
        container.querySelector('[data-sw-grid]').innerHTML = `<p class="sw-empty-results" role="status">${escape(t.error)}</p>`;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();



